export default [
	{
		title: 'carousel',
		load: () =>
			import(/* webpackChunkName: 'carousel' */ '../common.blocks/carousel'),
	},
	{
		title: 'product-images',
		load: () =>
			import(
				/* webpackChunkName: 'product-images' */ '../common.blocks/product-images'
			),
	},
	{
		title: 'mdc-text-field--webiq',
		load: () =>
			import(
				/* webpackChunkName: 'mdc-text-field' */ '../common.blocks/mdc-field/mdc-text-field'
			),
	},
	{
		title: 'mdc-select--webiq',
		load: () =>
			import(
				/* webpackChunkName: 'mdc-select' */ '../common.blocks/mdc-field/mdc-select'
			),
	},
	{
		title: 'phone-field',
		load: () =>
			import(
				/* webpackChunkName: 'phone-field' */ '../custom.blocks/phone-field'
			),
	},
]
